var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link p-0 modal-close-button",class:{ dark: _vm.dark, 'large-close': _vm.large },on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }